<template>
    <Numerics class="orders_fundings">
        <div class="transaction_table_holder">
            <table cellspacing="0">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>ID</th>
                        <th>Account ID</th>
                        <th>External Memo ID</th>
                        <th>Status</th>
                        <th>Type</th>
                        <th class="selectable" @click="$emit('changeSortFilters', 'created_at')">Created At <span class="asc_desc_arrow" v-if="sortFilters.column == 'created_at'">{{ sortFilters.direction == 'asc' ? '&#8638;' : '&#8642;' }}</span></th>
                        <th class="selectable" @click="$emit('changeSortFilters', 'executed_at')">Executed At <span class="asc_desc_arrow" v-if="sortFilters.column == 'executed_at'">{{ sortFilters.direction == 'asc' ? '&#8638;' : '&#8642;' }}</span></th>
                        <th class="selectable number" @click="$emit('changeSortFilters', 'base_amount')">Base Amount <span class="asc_desc_arrow" v-if="sortFilters.column == 'base_amount'">{{ sortFilters.direction == 'asc' ? '&#8638;' : '&#8642;' }}</span></th>
                        <th>Asset</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(order, index) in sortOrders(orders)" :key="index" :class="isOdd(index) ? 'even': ''" @click="selectedOrder = order">
                        <td>{{ index + 1 + "." }}</td>
                        <td>{{ order.id }}</td>
                        <td>{{ order.account_id }}</td>
                        <td>{{ order.external_memo_id }}</td>
                        <td :class="setStatusColor(order.order_status)">{{ setStatusText(order.order_status) }}</td>
                        <td>{{ order.order_funding_type }}</td>
                        <td>{{ order.created_at ? order.created_at.slice(0,10) + " " + order.created_at.slice(11,19) : "" }}</td>
                        <td>{{ order.executed_at ? order.executed_at.slice(0,10) + " " + order.executed_at.slice(11,19) : "" }}</td>
                        <td class="number">{{ parseFloat(order.base_amount).toFixed(2) }}</td>
                        <td>{{ order.asset_short_name }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <Transition name="item_explorer">
            <div class="item_explorer" v-if="selectedOrder">
                <div class="header">
                    <h3> {{ "Reallocation: " + selectedOrder.id }} </h3>
                </div>
                <div class="settings">
                    <div class="settings_content">
                        <div class="info_setting">
                            <span class="label">ID:</span>
                            <span class="info">{{ selectedOrder.id }}</span>
                        </div>
                        <div class="info_setting">
                            <span class="label">Account ID:</span>
                            <span class="info">{{ selectedOrder.account_id }}</span>
                        </div>
                        <div class="info_setting">
                            <span class="label">External Memo ID:</span>
                            <span class="info">{{ selectedOrder.external_memo_id }}</span>
                        </div>
                        <div class="info_setting">
                            <span class="label">Status:</span>
                            <span class="info">{{ setStatusText(selectedOrder.order_status) }}</span>
                        </div>
                        <div class="info_setting">
                            <span class="label">Type:</span>
                            <span class="info">{{ selectedOrder.order_funding_type }}</span>
                        </div>
                        <div class="info_setting">
                            <span class="label">Created At Date:</span>
                            <span class="info">{{ selectedOrder.created_at.slice(0,10) }}</span>
                        </div>
                        <div class="info_setting">
                            <span class="label">Created At Time:</span>
                            <span class="info">{{ selectedOrder.created_at.slice(11,19) }}</span>
                        </div>
                        <div class="info_setting">
                            <span class="label">Executed At Date:</span>
                            <span class="info">{{ selectedOrder.executed_at ? selectedOrder.executed_at.slice(0,10) : "" }}</span>
                        </div>
                        <div class="info_setting">
                            <span class="label">Executed At Time:</span>
                            <span class="info">{{ selectedOrder.executed_at ? selectedOrder.executed_at.slice(11,19) : "" }}</span>
                        </div>
                        <div class="info_setting">
                            <span class="label">Base Amount:</span>
                            <span class="info">{{ parseFloat(selectedOrder.base_amount).toFixed(2) + " " + selectedOrder.asset_short_name }}</span>
                        </div>
                    </div>
                </div>
                <div class="exit_options">
                    <input type="button" class="exit_option" value="Close" @click="closeExistingItemExplorer">
                </div>
            </div>
        </Transition>    
    </Numerics>
</template>

<script>
    import Numerics from "@/components/slots/numerics-slot.vue";

    export default {
        props: {
            orders: {
                Type: Array
            },
            sortFilters: {
                Type: Object
            }
        },

        components: {
            Numerics
        },

        data() {
            return {
                selectedOrder: null
            }
        },

        methods: {
            sortOrders(orders) {
                if (orders) {
                    // orders = orders.filter(
                    //     order => {
                    //         if (order.order_status == "FILLED") {
                    //             return true;
                    //         }
                    //     }
                    // );
                    orders = orders.sort(
                        (a, b) => {
                            return new Date(b.created_at) - new Date(a.created_at);
                        }
                    );
                }
                return orders;
            },

            closeExistingItemExplorer() {
                this.selectedOrder = null;
            },

            setSideColor(side) {
                if (side == "BUY") {
                    return "positive";
                }
                else if (side == "SELL") {
                    return "negative";
                }
            },

            setTypeColor(side) {
                if (side == "DEPOSIT") {
                    return "positive";
                }
                else if (side == "WITHDRAW") {
                    return "negative";
                }
            },

            setStatusText(status) {
                if (status == "FILLED") return "EXECUTED";
                else return status;
            },

            setStatusColor(status) {
                // if (status == "Open") {
                //     return "positive";
                // }
                if (status == "FILLED") {
                    return "positive";
                }
                // else if (status == "Partially Filled") {
                //     return "pending";
                // }
                else if (status == "PENDING_SUBMISSION") {
                    return "pending";
                }
                else if (status == "REJECTED") {
                    return "negative";
                }
                else if (status == "CANCELLED") {
                    return "incomplete";
                }
            },

            isOdd(num) {
                return num % 2 !== 0;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .orders_fundings {
        width: 100%;

        .transaction_table_holder {
            width: 100%;
            overflow: auto;

            table {
                width: 100%;
                overflow-x: auto;
    
                thead {
                    width: 100%;
    
                    tr {
                        position: sticky;
                        top: 0;
                        border-radius: 5px;
    
                        th {
                            height: 10px;
                            font-size: 14px;
                            font-weight: 300;
                            text-align: left;

                            &.number {
                                text-align: right;
                            }

                            &.selectable {
                                &:hover {
                                    cursor: pointer;
                                    background-color: #444;
                                }
                            }
                        }
    
                        :first-child {
                            padding-left: 10px;
                        }
    
                        :last-child {
                            padding-right: 10px;
                        }
                    }
                }
    
                tbody {
                    width: 100%;
    
                    tr {
                        border-radius: 5px;
    
                        td {
                            height: 10px;
                            font-size: 12px;
                            font-weight: 500;
                            text-align: left;

                            &.number {
                                text-align: right;
                            }
    
                            input {
                                height: 30px;
                                padding: 4px 8px;
                                text-align: center;
                                font-size: 13px;
                            }
                        }
    
                        :first-child {
                            padding-left: 10px;
                        }
    
                        :last-child {
                            padding-right: 10px;
                        }
    
                        &.even {
                            background-color: #2E2E2E;
                        }
    
                        &:hover {
                            background-color: #444;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
</style>